export default {
  methods: {
    /**
     * Возвращает величину шага сетки на графике в зависимости от минимального, максимального значений и кол-ва засечек
     * @param min Минимальное значение
     * @param max Максимальное значение
     * @param numTicks Кол-во засечек
     * @returns {number|number}
     */
    getStepSize (min, max, numTicks) {
      const limit = max < 10
        ? 10
        : max < 100
          ? 100
          : max < 1000
            ? 1000
            : max < 10000
              ? 1000
              : max < 100000
                ? 100000
                : 1000000
      const diff = max - min
      const nearest = diff > 0
        ? diff / limit
        : 0
      const value = nearest * limit / numTicks
      return value > 1.0
        ? Math.round(value)
        : value
    }
  }
}
